import * as React from 'react';

import { Button, Dialog } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-learners';

const { HeadingGroup, Content, Actions } = Dialog;

export type CsvInviteModalProps = {
  open: boolean;
  onClose: () => void;
  onBack: () => void;
  /** Set when the group step should be skipped — consumed once this flow is built out (Task 3/5). */
  autoSelectedGroupId?: string;
};

/**
 * Placeholder for the CSV bulk-invite flow (ENTADMIN-1951 scaffolding only).
 * Replaced by the real upload/preview/processing pipeline in a later Phase A task.
 */
const CsvInviteModal = ({ open, onClose, onBack, autoSelectedGroupId }: CsvInviteModalProps) => (
  <Dialog open={open} onClose={onClose}>
    <HeadingGroup>{_t('Invite learners using CSV')}</HeadingGroup>
    <Content>{autoSelectedGroupId && <span data-testid="auto-selected-group-id">{autoSelectedGroupId}</span>}</Content>
    <Actions>
      <Button variant="secondary" onClick={onBack}>
        {_t('Back')}
      </Button>
    </Actions>
  </Dialog>
);

export default CsvInviteModal;
